import { Link } from "react-router-dom";
import { ArrowRight, Package, ShoppingBag, Gift } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "../store/Reveal";
import { useCart } from "../../context/CartContext";

export const BundleSection = ({ bundle }) => {
  const { addItem, setOpen } = useCart();
  if (!bundle) return null;
  const savings = (bundle.original_price || 0) - bundle.price;

  const addToCart = () => {
    addItem(bundle, 1);
    toast.success("Box Degustazione aggiunto al carrello!");
    setOpen(true);
  };

  return (
    <section data-testid="bundle-section" className="max-w-7xl mx-auto px-4 sm:px-8 pb-20 lg:pb-28">
      <div className="rounded-[2rem] border border-[#E7E0D8] bg-white overflow-hidden grid lg:grid-cols-2">
        <div className="grid grid-cols-3 gap-px bg-[#E7E0D8]">
          {(bundle.bundle_items || []).slice(0, 6).map((it) => (
            <Link key={it.slug} to={`/prodotto/${it.slug}`} data-testid={`bundle-item-${it.slug}`} className="relative aspect-square group overflow-hidden bg-[#F5F0EB]">
              <img src={it.image} alt={it.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent text-white text-[10px] font-medium p-2 leading-tight opacity-0 group-hover:opacity-100 transition-opacity">{it.name}</span>
            </Link>
          ))}
        </div>
        <div className="p-8 lg:p-12 flex flex-col justify-center">
          <Reveal>
            <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#2E8A57] mb-3 flex items-center gap-2">
              <Package className="w-4 h-4" /> Novità · Per i nuovi clienti
            </p>
            <h2 className="font-serif-display font-bold text-2xl sm:text-3xl lg:text-4xl text-[#1C1917] tracking-tight">
              Box Degustazione <span className="italic text-[#2E8A57]">— I Best Seller</span>
            </h2>
            <p className="mt-4 text-[#44403C] leading-relaxed max-w-md">
              I nostri {bundle.bundle_items?.length || 6} piatti più amati in un unico box:
              il modo perfetto per scoprire la cucina italiana gluten free, con uno sconto del {bundle.bundle_discount_percent || 15}%.
            </p>
            <div className="mt-6 flex items-baseline gap-3 flex-wrap">
              <span data-testid="bundle-price" className="font-serif-display font-bold text-4xl text-[#2E8A57]">{bundle.price.toFixed(2).replace(".", ",")} €</span>
              {bundle.original_price && (
                <span data-testid="bundle-original-price" className="font-mono-accent text-lg text-[#B4ADA3] line-through">{bundle.original_price.toFixed(2).replace(".", ",")} €</span>
              )}
              {savings > 0 && (
                <span className="rounded-full bg-[#7DC242]/15 text-[#3C6E53] px-3.5 py-1.5 text-xs font-bold">Risparmi {savings.toFixed(2).replace(".", ",")} €</span>
              )}
            </div>
            <div className="mt-8 flex flex-wrap gap-4">
              <button data-testid="bundle-add-to-cart" onClick={addToCart} className="btn-tuscan inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-sm tracking-wide">
                <ShoppingBag className="w-4 h-4" /> Aggiungi al carrello
              </button>
              <Link to={`/prodotto/${bundle.slug}`} data-testid="bundle-detail-link" className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-sm tracking-wide border border-[#1C1917] hover:bg-[#1C1917] hover:text-[#FDFBF7] transition-colors duration-300">
                Scopri il box <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
            <p className="mt-4 inline-flex items-center gap-2 text-xs font-semibold text-[#B4831A]">
              <Gift className="w-4 h-4" /> Perfetto da regalare: al checkout puoi aggiungere un biglietto personalizzato
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
